<ng-container *ngIf="isOpen">
	<div class="csp-backdrop" (click)="attemptClose()"></div>
	<aside class="csp-panel" role="dialog" aria-modal="true" aria-label="Client Settings">
		<header class="csp-header">
			<div class="csp-header-titles">
				<h5 class="csp-title"><i class="fa fa-cog mr-2" aria-hidden="true"></i>Client Settings</h5>
				<div class="csp-client-id" *ngIf="clientId">
					<span class="csp-client-id-label">Client ID:</span>
					<span class="csp-client-id-value">{{ clientId }}</span>
				</div>
			</div>
			<button type="button" class="csp-close" aria-label="Close" title="Close" (click)="attemptClose()">
				<i class="fa fa-times" aria-hidden="true"></i>
			</button>
		</header>
		<div class="csp-body">
			<app-modify [clientId]="clientId" [isPanelMode]="true" (requestClose)="attemptClose()"></app-modify>
		</div>
	</aside>
</ng-container>
